import { PDF_DPE_EMBED_PATH } from '@/shared/constants/navegacao';
import './utilitario-embed.css';

/**
 * Página interna que embute o editor PDF DPE (I Love DPE) via iframe.
 * O iframe aponta para `/pdf-dpe/` (proxy same-origin na API), evitando
 * bloqueio de conteúdo misto quando o SGI está em HTTPS.
 */
export default function PdfDpePage() {
  return (
    <div className="utilitario-embed">
      <iframe
        className="utilitario-embed__frame"
        src={PDF_DPE_EMBED_PATH}
        title="PDF DPE — editor de PDF da Defensoria"
        allow="fullscreen; clipboard-read; clipboard-write; downloads"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
